<form nz-form style="padding-top:12px;padding-right:12px" autocomplete="off" [formGroup]="validateForm">
  <div nz-row [nzGutter]="['0','0']" class="import">
    <div nz-col nzSm="24" nzMd="24">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="schoolId" >Cơ sở</nz-form-label>
        <nz-form-control nzSpan="24" nzErrorTip="Nhập trường thông tin bắt buộc">
          <asc-autocomplete label="Cơ sở" [ascModel]="schoolControl"
            (ascModelChange)="changeSchool($event)" placeholder="Chọn cơ sở..." formControlName="schoolId"
            [getListAC]="getSchoolACFn">
          </asc-autocomplete>
        </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="maCS" nzRequired>Chọn file</nz-form-label>
        <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton" >
          <input type="text" nz-input [value]="importStaff.tenFile" placeholder="Chọn file" />
        </nz-input-group>
        <ng-template #suffixIconButton>
          <button nz-button nzType="primary" nzSearch (click)="suffixFileClick()" id="button-file" matSuffix><i nz-icon nzType="paper-clip"></i></button>
        </ng-template>
        </nz-form-item>
      <input #file id="file-selector" type="file" style="display:none;" (change)="finishUpload($event.target.files)">
    </div>
    <div nz-col nzSpan="24">
      <nz-form-item>
        <nz-form-label #label nzFor="typeOfPersonnel"><b>Loại nhân sự</b></nz-form-label>
        <nz-form-control nzErrorTip="Nhập trường thông tin bắt buộc">
          <nz-radio-group [(ngModel)]="importStaff.typeOfPersonnel" [ngModelOptions]="{standalone: true}" nzButtonStyle="solid" (ngModelChange)="onChangeStatus($event)">
            <ng-container *ngFor="let item of typeOfPersonnels">
              <label nz-radio [nzValue]="item.id">{{item.typeOfPersonnelName}}</label>
            </ng-container>
          </nz-radio-group>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="24">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="tenCS" nzRequired>Kết quả import</nz-form-label>
          <textarea nz-input [style.color]="discoloration == true ? 'green' : 'brown'" [value]="importStaff.ketQuaImport" ></textarea>
      </nz-form-item>
    </div> 
  </div>
  <div *nzModalFooter>
    <div class="card-footer text-right">
      <button nz-button (click)="close()" [disabled]="isImporting">Đóng</button>
      <button nz-button (click)="taiVe()" [disabled]="isImporting">Tải về</button>&nbsp;
      <button nz-button nzType="primary" (click)="import()" [nzLoading]="isImporting" type="submit">Import</button>
    </div>
  </div>
</form>